import { namespacedConsts } from '../../jsCore/utils/object';

export const YOUTUBE_ACTION_TYPES = namespacedConsts({
  SDK_LOADED: true,
  LOAD_SDK: true,
  ANALYTICS: {
    VIDEO_PLAY: true,
    VIDEO_COMPLETE: true,
    VIDEO_PAUSE: true,
    VIDEO_PERCENTAGE_CHANGE: true,
  }
});

export const loadSdk = _ => ({
  type: YOUTUBE_ACTION_TYPES.LOAD_SDK,
});

export const sdkLoaded = _ => ({
  type: YOUTUBE_ACTION_TYPES.SDK_LOADED,
});

export const youtubeAnalyticsPlayAction = function(videoId, pageType, videoMainWrapperName, time) {
  return {
    type: YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PLAY,
    state: {
      payload: {
        category: pageType,
        action: `youtube ${videoMainWrapperName} video play`,
        label: videoId,
        sub_label: `current position=${time.position}sec; video duration=${time.duration}sec;`,
      },
    },
  };
};

export const youtubeAnalyticsCompleteAction = (videoId, pageType, videoMainWrapperName, time) => ({
  type: YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_COMPLETE,
  state: {
    payload: {
      category: pageType,
      action: `youtube ${videoMainWrapperName} video complete`,
      label: videoId,
      sub_label: `current position=${time.position}sec; video duration=${time.duration}sec;`,
    },
  },
});

export const youtubeAnalyticsPauseAction = (videoId, pageType, videoMainWrapperName, time) => ({
  type: YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PAUSE,
  state: {
    payload: {
      category: pageType,
      action: `youtube ${videoMainWrapperName} video paused`,
      label: videoId,
      sub_label: `current position=${time.position}sec; video duration=${time.duration}sec;`,
    },
  },
});

export function youtubeAnalyticsPercentageChangeAction(videoId, pageType, videoMainWrapperName, time, percentage){
  return {
    type: YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PERCENTAGE_CHANGE,
    state: {
      payload: {
        category: pageType,
        label: videoId,
        sub_label: `current position=${time.position}sec; video duration=${time.duration}sec;`,
        action: `youtube ${videoMainWrapperName} video ${percentage}% complete`,
      },
    },
  };
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/track_analytics_youtube_events/youtubeActions.js